export default __webpack_public_path__ + "static/media/balcony-bw.cde07589.jpg";